import React, { Component } from 'react';
import Common_Header_En from './common/views/header/Common_Header_En';
import Accessibility from './common/package/accessibility/Accessibility';
import Common_Footer_En from './common/views/footer/Common_Footer_En';
import { Outlet } from 'react-router-dom';
import icon_building from './images/img-building.png'
export class Layout_En extends Component {
    static displayName = Layout_En.name;

    /**
     * ���Xfooter�a��
     * */
    Collapse() {
        document.getElementById("condensation").onclick = () => {
            const webMap = document.getElementById("webmap");
            var footer = document.querySelector('.footer');
            console.log(webMap.offsetHeight);
            if (webMap.offsetHeight) {

                webMap.style.display = "none";
                webMap.style.height = "0px";
                webMap.style.padding = "0";
            } else {
                webMap.style.height = "auto";
                webMap.style.padding = "5rem 0 2rem";
                webMap.style.display = "block";
            }
        };
    }

  render() {
    return (
        <>
            <Accessibility lang="en" />
            <Common_Header_En />
            <div className="content" id="mainContent">
                <div className="layout_content">
                    <Outlet />
                </div>
                <img className="bg-pos-1" src={icon_building} alt="" />
            </div>
           
            <Common_Footer_En />
        </>
    );
  }
}
